import script from "./MyNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyNav.vue?vue&type=script&setup=true&lang=ts"

import "./MyNav.vue?vue&type=style&index=0&id=f93e3ea0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f93e3ea0"]])

export default __exports__